import Container from "@mui/material/Container";
import MKBox from "components/MKBox";
import DefaultNavbar from "devComponents/Navbars/PublicNavbar";
import MKTypography from "components/MKTypography";
import ProjectsList from "./ProjectsList";
import { motion } from "framer-motion";

const Index = () => {
  return (
    <MKBox
      sx={{
        backgroundColor: "#0f172a", // Dark slate background
        background: "linear-gradient(to bottom right, #0f172a, #1e293b)",
        minHeight: "100vh",
        position: "relative",
        overflowX: "hidden",
      }}
    >
      <MKBox sx={{ position: "relative", zIndex: 10 }}>
        <DefaultNavbar />
      </MKBox>

      {/* Hero Section */}
      <MKBox
        component={motion.div}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        sx={{
          pt: 5,
          pb: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 2,
          position: "relative",
          zIndex: 1,
        }}
      >
        <Container>
          <MKTypography
            variant="h1"
            color="white"
            sx={{
              fontWeight: "800",
              letterSpacing: "-1px",
              background: "white",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "2.5rem", md: "4rem" },
            }}
          >
            Our Past Projects
          </MKTypography>
        </Container>
      </MKBox>

      {/* Projects Section */}
      <MKBox pb={5} sx={{ position: "relative", zIndex: 1 }}>
        <Container>
          <ProjectsList />
        </Container>
      </MKBox>

      {/* Background decoration elements */}
      <MKBox
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
          pointerEvents: "none",
          overflow: "hidden",
        }}
      >
        <MKBox
          sx={{
            position: "absolute",
            top: "-10%",
            left: "-10%",
            width: "50vw",
            height: "50vw",
            background: "radial-gradient(circle, rgba(59,130,246,0.15) 0%, rgba(0,0,0,0) 70%)",
            borderRadius: "50%",
            filter: "blur(60px)",
          }}
        />
        <MKBox
          sx={{
            position: "absolute",
            bottom: "-10%",
            right: "-10%",
            width: "50vw",
            height: "50vw",
            background: "radial-gradient(circle, rgba(168,85,247,0.15) 0%, rgba(0,0,0,0) 70%)",
            borderRadius: "50%",
            filter: "blur(60px)",
          }}
        />
      </MKBox>
    </MKBox>
  );
};

export default Index;
